import lottie from "lottie-web";
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { applyBrandColors, MOBILE_FILE_COLOR_MAP, computeResolvedVars } from '../../utils/lottieColorUtils';

const TableAnimationFiles = React.forwardRef((props, ref) => {
  const container = useRef(null);
  const primaryColor = useSelector(state => state['Settings']?.['currentBranding']?.['primaryColor']);
  const isCustomBranding = useSelector(state => state['Settings']?.['isCustomBranding']);
  const brandingLoaded = useSelector(state => state['Settings']?.['brandingLoaded']);

  useEffect(() => {
    if (!brandingLoaded) return;
    let animation;
    let cancelled = false;
    const resolvedVars = isCustomBranding ? computeResolvedVars(primaryColor) : {};
    fetch('/animation/mobile-file.json')
      .then(r => r.json())
      .then(data => {
        if (cancelled || !container.current) return;
        container.current.innerHTML = ''; // remove any stale SVG so only the fresh brand-colored one renders
        animation = lottie.loadAnimation({
          container: container.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: applyBrandColors(data, MOBILE_FILE_COLOR_MAP, resolvedVars),
        });
      });
    return () => { cancelled = true; animation?.destroy(); };
  }, [primaryColor, brandingLoaded]);

  return (
    <div className="svg-animation-loader" ref={container} style={{ width: "400px", height: "400px", background: "transparent" }} />
  );
});

export default TableAnimationFiles;
